var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Authorization Code")]),(_vm.code)?_c('p',[_vm._v("Authorization code: "+_vm._s(_vm.code))]):_c('p',[_vm._v("No authorization code received.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }